import { isOwnedByCurrentUser, getOwnerName } from 'documents-ui/utils/owner';
import { BreakString } from 'foundations-components/transitional/components/BreakString';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const NotOwnedWarning = ({
  type,
  searchResults
}) => {
  const count = searchResults.size;
  const userView = searchResults.first().get('userView');
  const isOwned = searchResults.every(result => isOwnedByCurrentUser(result.get('userId')));
  if (isOwned) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Alert, {
    "data-test-id": "not-owned-warning-alert",
    type: "warning",
    marginBlockEnd: "400",
    children: [/*#__PURE__*/_jsx(Text, {
      typography: "heading-100",
      marginBlockEnd: "200",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "notOwnedWarning.title"
      })
    }), /*#__PURE__*/_jsx(BreakString, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `notOwnedWarning.${type}`,
        options: {
          count,
          owner: getOwnerName(userView)
        }
      })
    })]
  });
};
export default NotOwnedWarning;